import BaseModel from '../core/BaseModel';

export default class extends BaseModel {

    constructor() {
        super({
                name: "reviews",
                tableName: 'reviews',
                label: "reviews",
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                author: {
                    name: 'author',
                    type: "String",
                    label: 'author',
                    width: 8,
                },
                stars: {
                    name: 'stars',
                    type: "String",
                    label: 'stars',
                    width: 5,
                },
                comment: {
                    name: 'comment',
                    type: "String",
                    label: 'comment',
                    width: 15,
                },
                 avatar: {
                    name: 'avatar',
                    label: 'Image',
                    custom: 'image',
                    type: 'Computed',
                    computed: (data, index) => {
                        data.avatar = index + 1;
                    },
                    width: 5,
                    class: 'left',
                },
               
                active: {
                    name: 'active',
                    label: 'Active',
                    type: 'Selection',
                    custom: 'SelectionText',
                    options: [
                        { value: 'true', label: 'Yes', style: 'color:  #000000;' },
                        { value: 'false', label: 'No', style: 'color:  #000000;' },
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals',
                    },
                    class: 'active-css',
                    width: 5,
                },
                ordinal : {
                    name: 'ordinal',
                    type: "Number",
                    label: 'Ordinal',
                    default: 0,
                    width: 3,
                    class: "center",
                },
                created_by : {
                    name: 'created_by',
                    type: "String",
                    label: 'Created By',
                    display: false
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    label: 'Created At',
                    display: false
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Update At',
                    display: false
                },
            })
    }
}
